import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AuthService } from '../../../../core';
import { PedidoFilter } from '../../../pedido/filter/pedido-filter';
import { PedidoPedidoListComponent } from '../../../pedido/pedido/list/pedido-pedido-list.component';
import { PedidoStatusPipe } from '../../../pedido/status/pipes';
import { PedidoAuthGuardService, PedidoRouterService } from '../../../pedido/services';
import { Pessoa } from '../../pessoa';
import { Cliente } from '../cliente';
import { PedidoExcelListagemModalComponent } from '../../../pedido/excel/listagem';
import { PedidoSearchOrderBy } from '../../../pedido/pedido-search-orderby';

interface Config {
    canInsertPedido: boolean;
}

@Component({
    selector: 'sgt-cliente-pedido',
    templateUrl: './cliente-pedido.component.html',
    styleUrls: ['./cliente-pedido.component.less'],
    providers: [
        PedidoStatusPipe
    ]
})
export class ClientePedidoComponent implements OnInit {
    config: Config;

    @Input() entity: Cliente;
    @Input() pessoa: Pessoa;
    @Input() idRepresentante: number;
    isRepresentante: boolean;

    filter = new PedidoFilter();
    @ViewChild('container') container: ElementRef;
    @ViewChild('list') list: PedidoPedidoListComponent;

    /** Modal para exportar os pedidos para Excel */
    @ViewChild('pedidoExcelListagemModal') pedidoExcelListagemModal: PedidoExcelListagemModalComponent;

    constructor(private activatedRoute: ActivatedRoute,
                private authService: AuthService,
                private pedidoAuthGuardService: PedidoAuthGuardService,
                private pedidoRouterService: PedidoRouterService) { }

    ngOnInit() {
        this.isRepresentante = this.authService.isRepresentante();

        if (this.pessoa && this.pessoa.id) {
            this.search();
        }

        this.setConfig();
    }

    private setConfig() {
        this.config = {
            canInsertPedido: this.pedidoAuthGuardService.canInsert(this.authService.getPerfilUsuario())
        }
    }

    onFilterInitialized() {
        this.search();
    }

    /** Quando o filtro é alterado */
    onFilterChange() {
        this.search();
    }

    private search() {
        if (!this.pessoa || !this.pessoa.id) {
            return
        }

        // Sempre setando o ID da pessoa do cliente
        this.filter.idPessoa = this.pessoa.id;
        this.list?.search();
    }

    resize() {
        jQuery(window).trigger('resize');
    }

    insertPedido() {
        if (!this.config.canInsertPedido) {
            return;
        }

        this.pedidoRouterService.insert(this.activatedRoute, null, null, this.entity?.id ?? null, this.pessoa?.id ?? null);
    }

    /** Abre modal para exportar os pedidos para Excel */
    openPedidosExcelListagemModal() {
        // Sempre setando o ID da pessoa do cliente
        this.filter.idPessoa = this.pessoa.id;
        this.pedidoExcelListagemModal.open(this.filter, PedidoSearchOrderBy.DataEmissao, 'desc');
    }
}
